// import { Badge } from "@mantine/core";

export default function GlassCard({ 
  img, 
  badgeColor, 
  badgeText, 
  title, 
  description, 
  techStack = [],
  githubLink,
  demoLink
}) {
  return (
    <div className="glass projects-card relative flex flex-col h-full">
      {/* Badge positioned on top of image */}
      <div className="relative">
        <img src={img || "/placeholder.svg"} className="rounded-t-lg h-48 w-full object-cover" alt={title} />
        
        {/* Badge overlay on image */}
        <div className="absolute top-3 right-3">
          <div
            className="badge-style  text-sm "  
          >
            {badgeText}
          </div>
        </div>
        
        {/* Optional: Gradient overlay for better text readability */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent rounded-t-lg"></div>
      </div>

      {/* Content section */}
      <div className="project-card-desc">
        <h3 className="text-lg font-bold text-white text-justify leading-tight">{title}</h3>
        <p className="text-xs text-white/50 leading-3 text-justify mt-2 ">{description}</p>
        
        {/* Tech stack chips */}
        {techStack.length > 0 && (
          <div className="flex flex-wrap gap-2 mt-3">
            {techStack.map((tech, index) => (
              <span
                key={index}
                className="inline-block text-xs font-medium grey-chips-style"
              >
                {tech}
              </span>
            ))}
          </div>
        )}

        <div className="w-full gap-3 flex">
          {githubLink && (
            <div onClick={() => window.open(githubLink, "_blank")} className="h-max flex-1 bg-slate-950 text-white rounded-3xl border border-white/20 mt-3">
              GITHUB
            </div>
          )}

          {demoLink && (
            <div onClick={() => window.open(demoLink, "_blank")} className="h-max flex-1 bg-white text-slate-950 rounded-3xl border border-white/20 mt-3">
              DEMO
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
